export default __webpack_public_path__ + "static/5_34-1--54b578b168005de1b91079c6c66c2b6a.png";